var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _defs, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _defs2, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7986CB;}\n\t.st1{fill:#80D8FF;}\n\t.st2{fill:#3E4D70;}\n\t.st3{fill:#E3F2FD;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FFC34A;}\n\t.st6{fill:#D0DAFC;}\n\t.st7{fill:#4053AD;}\n\t.st8{fill:#FF9E80;}\n\t.st9{fill:#223056;}\n\t.st10{fill:#F4C9C9;}\n\t.st11{fill:#3359C4;}\n\t.st12{fill:#ECEFF1;}\n\t.st13{fill:#9DE3FC;}\n\t.st14{fill:#B8BFDD;}\n\t.st15{fill:#E4E8F4;}\n\t.st16{fill:#D3D9EA;}\n\t.st17{fill:#FFD740;}\n\t.st18{fill:#D5DEE2;}\n\t.st19{clip-path:url(#SVGID_2_);}\n\t.st20{fill:#FEFFFF;}\n\t.st21{fill:#FEFEFF;}\n\t.st22{fill:#FDFEFF;}\n\t.st23{fill:#FCFEFF;}\n\t.st24{fill:#FBFDFF;}\n\t.st25{fill:#FAFDFF;}\n\t.st26{fill:#F9FCFF;}\n\t.st27{fill:#F8FCFE;}\n\t.st28{fill:#F7FBFE;}\n\t.st29{fill:#F5FBFE;}\n\t.st30{fill:#F4FAFE;}\n\t.st31{fill:#F3F9FE;}\n\t.st32{fill:#F2F9FE;}\n\t.st33{fill:#F0F8FE;}\n\t.st34{fill:#EFF8FE;}\n\t.st35{fill:#EDF7FE;}\n\t.st36{fill:#ECF6FE;}\n\t.st37{fill:#EAF5FE;}\n\t.st38{fill:#E8F5FD;}\n\t.st39{fill:#E7F4FD;}\n\t.st40{fill:#E5F3FD;}\n\t.st41{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.6099,
    y: 238.8584,
    className: "st0",
    width: 3.7793,
    height: 101.0635
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 593.5054,
    y: 166.0996,
    className: "st0",
    width: 3.7793,
    height: 175.6299
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7582,331.7257c-8.8891-29.3737-5.3122-62.3031,9.6766-89.0831 c30.7306,10.5705,55.6905,36.615,64.9449,67.7674c6.8152,22.9416,4.9857,48.215-4.4288,70.1624 c-4.1856,9.7577-7.9651,22.7147-19.5944,16.1062c-11.2858-6.4133-21.345-15.6972-29.5328-25.6971 C204.3578,359.4205,197.0889,346.0365,192.7582,331.7257z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.0948,371.5049c-14.924-26.8161-18.4216-59.7541-9.4616-89.1062 c32.2746,3.8035,62.1959,23.9536,77.8546,52.4302c11.5316,20.9711,15.1109,46.0565,10.5717,69.5027 c-2.018,10.4239-2.9598,23.888-15.7272,19.8998c-12.3903-3.8705-24.1915-10.8064-34.3162-18.8396 C188.311,396.1048,178.3658,384.5696,171.0948,371.5049z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.3711,327.8915c-12.2242-22.2305-33.1407-39.3858-57.083-47.6519 c-0.5075,3.1201-0.8652,6.2618-1.1195,9.4128c21.4283,8.9153,39.9201,25.0163,51.1172,45.3791 c10.5393,19.1664,14.4138,41.7664,11.5411,63.4137c2.9747-0.7676,5.182-3.3705,7.0276-6.6878 C261.8419,369.9731,257.9837,347.1913,247.3711,327.8915z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.6019,422.59c-0.3044,0-0.576-0.2175-0.6327-0.5287 c-11.8473-65.1572-78.1287-136.8996-78.7978-137.6163c-0.2414-0.2604-0.2275-0.6678,0.0327-0.9099 c0.2616-0.2427,0.6678-0.2289,0.9105,0.032c0.6703,0.72,67.2058,72.7328,79.1223,138.2641 c0.0628,0.3496-0.1685,0.6847-0.5181,0.7482C240.6798,422.587,240.6409,422.59,240.6019,422.59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.1816,335.3963c-0.0403,0-0.0817-0.0038-0.122-0.0113c-0.3496-0.0667-0.5785-0.4044-0.5119-0.7533 l6.357-33.2828c0.0666-0.3496,0.4112-0.5791,0.7532-0.5119c0.3496,0.0667,0.5785,0.4044,0.5118,0.7533l-6.3569,33.2829 C201.7537,335.1819,201.4834,335.3963,201.1816,335.3963z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.2376,373.2389c-0.0805,0-0.1622-0.0151-0.2414-0.047c-0.3295-0.1334-0.4892-0.5088-0.3559-0.8383 l15.3119-37.8426c0.1345-0.3301,0.5093-0.488,0.8387-0.3553c0.3295,0.1333,0.4893,0.5087,0.356,0.8382l-15.3119,37.8426 C223.7332,373.0868,223.4917,373.2389,223.2376,373.2389z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.005,310.2805h-26.001c-0.3559,0-0.6439-0.2879-0.6439-0.6438c0-0.3558,0.288-0.6438,0.6439-0.6438 h26.001c0.3559,0,0.6439,0.288,0.6439,0.6438C183.6489,309.9926,183.3609,310.2805,183.005,310.2805z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.0496,351.0747h-48.73c-0.3559,0-0.6438-0.288-0.6438-0.6438c0-0.3559,0.2879-0.6439,0.6438-0.6439 h48.73c0.3558,0,0.6438,0.288,0.6438,0.6439C211.6934,350.7867,211.4054,351.0747,211.0496,351.0747z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.6773,392.2907c-0.01,0-0.0214,0-0.0327-0.0006l-48.7173-2.5088 c-0.3559-0.0182-0.6288-0.3213-0.6099-0.6765c0.0176-0.3534,0.2741-0.6388,0.6753-0.6099l48.7173,2.5088 c0.3559,0.0182,0.6288,0.3213,0.6099,0.6766C231.3023,392.0236,231.0181,392.2907,230.6773,392.2907z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.6769,
    y: 417.5829,
    className: "st5",
    width: 66.025,
    height: 66.0251
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 400,
    cy: 506.7858,
    rx: 341.4947,
    ry: 31.2142
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "590.5264,455.8204 627.5187,460.9086 620.0654,496.1969 588.1754,491.8104  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "660.4563,447.8136 683.3591,418.3215 710.1929,442.4204 690.4492,467.8447  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "688.4873,383.2491 674.3977,348.6687 708.6849,337.4793 720.8311,367.2901  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "646.5883,326.6913 609.5959,321.603 617.0493,286.3148 648.9392,290.7012  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "576.6582,334.6981 553.7555,364.1903 526.9216,340.0914 546.6654,314.6671  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.6273,399.2626 562.717,433.8431 528.4298,445.0324 516.2835,415.2217  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.6087,317.7524c-40.5947,16.5402-60.0948,62.8571-43.5549,103.452 c16.5401,40.5948,62.8573,60.095,103.4521,43.5548c40.5946-16.54,60.0948-62.857,43.5547-103.4518 C675.5206,320.7126,629.2035,301.2124,588.6087,317.7524z M634.7268,399.9349c-4.7932,8.9302-15.9183,12.2838-24.8486,7.4905 c-8.9302-4.7933-12.2839-15.9184-7.4904-24.8487c4.7933-8.9301,15.9183-12.2837,24.8486-7.4904 C636.1667,379.8795,639.5202,391.0047,634.7268,399.9349z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M641.8235,443.8602c-29.0063,12.8291-63.0414-0.3318-75.8705-29.3381 c-12.8292-29.0065,0.3318-63.0415,29.3381-75.8706c29.0065-12.8291,63.0415,0.3318,75.8706,29.3382 C683.9908,396.996,670.83,431.031,641.8235,443.8602z M596.2381,340.7925c-27.8257,12.3069-40.451,44.957-28.1441,72.7826 c12.3068,27.8256,44.957,40.451,72.7826,28.1441c27.8256-12.3068,40.451-44.957,28.1441-72.7827 C656.7138,341.111,624.0637,328.4856,596.2381,340.7925z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M675.6654,356.3359c-0.5242,0.2319-1.1532,0.0489-1.4653-0.4517 c-15.0341-24.1178-43.7941-36.2546-71.5661-30.2021c-0.6314,0.138-1.2548-0.2625-1.3925-0.8947 c-0.138-0.6314,0.2578-1.2583,0.8947-1.3924c28.7352-6.2628,58.4941,6.2958,74.0509,31.2503 c0.342,0.5487,0.1746,1.2709-0.3741,1.6129C675.7649,356.2882,675.7156,356.3138,675.6654,356.3359z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M634.1697,426.5551c-19.4639,8.6085-42.3029-0.2229-50.9116-19.6869 c-8.6086-19.4639,0.223-42.3029,19.687-50.9115c19.4639-8.6087,42.3029,0.2229,50.9116,19.6868 C662.4652,395.1074,653.6336,417.9465,634.1697,426.5551z M603.8919,358.0976c-18.2836,8.0867-26.5794,29.54-18.4928,47.8236 c8.0865,18.2837,29.54,26.5795,47.8237,18.4928c18.2836-8.0865,26.5793-29.54,18.4928-47.8236 C643.6289,358.3067,622.1756,350.011,603.8919,358.0976z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M631.1862,219.5339c0,0,1.64,1.8095-2.7193,10.7914c-0.2592,0.5339-0.9055,0.7612-1.4478,0.5199 c-2.3217-1.0329-4.3662-2.778-4.3662-2.778l-1.4601-5.5945C621.1928,222.4727,622.6358,211.5749,631.1862,219.5339z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M610.3932,271.2681l2.4353,0.4831c1.8031-0.9639,5.3097-2.7078,11.9359-5.6532 c10.7157,6.5618,37.075,4.9212,38.8249,12.4674c1.7498,7.5458-6.0149,43.4162-6.0149,43.4162s-1.9969,0.1018-6.9182-0.8825 c-0.9429-11.1674-1.4479-30.461-1.5184-33.7982c-4.4171-0.3868-30.9609,0.3065-33.1684-2.0558 C609.9428,278.796,610.3932,271.2681,610.3932,271.2681z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M660.9264,254.8202h-2.2644c-0.388,0-0.7523,0.1859-0.9799,0.5l-10.4615,14.4364l2.4915,0.4658 L660.9264,254.8202z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "625.0578,229.1224 623.3959,234.8948 617.0604,229.0229 620.0864,224.1705 622.7123,223.831  "
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "625.2606,229.0724 623.4579,226.7288 624.6228,231.2881  "
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M617.1459,222.3708c0.0829-2.0601,1.5809-2.2866,1.8221-2.3414c2.0676-0.8667,2.4452-2.7997,3.48-4.8159 c1.1453-2.2316,4.5314-1.3941,5.2592-0.3494c1.8269,2.6223,6.6475,0.2873,5.6085,5.2836 c-1.2212,3.6617-4.8998-0.7912-4.8998-0.7912c-0.7218,0.6636-0.6107,1.324-1.272,2.386 c-0.9408,1.5105-1.6483,0.8031-2.7958,0.1477c-1.1473-0.6553-2.3706,1.2722-1.4717,2.8444 c-0.9621,0.6167-2.0191,0.5891-2.749,0.459l-0.0003,0.0004l-0.0051-0.0013c-0.5301-0.0949-0.8913-0.2417-0.8913-0.2417 s0.0177-0.0337,0.0254-0.0485C618.3173,224.5229,617.0903,223.75,617.1459,222.3708z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M622.7647,224.6844c0,0,0.3685,0.2287,1.3318,0.1902c0.45,0.7141,0.8918,1.6146,1.9814,2.5432 c1.5522-0.8925,3.1598-0.5624,3.9118-0.3224c-0.4008,0.9996-0.888,2.1118-1.5016,3.3758c-0.264,0.5439-0.9012,0.7206-1.475,0.5297 C621.7107,229.2359,622.7647,224.6844,622.7647,224.6844z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.2004,228.176c0,0-7.6363,4.849-9.2073,14.0646c-1.5711,9.2155-2.2384,20.2258,2.858,33.3484 c13.3784-4.3076,16.3348-7.5586,16.3348-7.5586s3.2726-17.8881,2.3979-22.5186c-0.8747-4.6307-5.0947-12.6852-5.0947-12.6852 L617.2004,228.176z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "616.996,228.1538 622.8011,235.9895 624.5626,232.9565 617.9734,227.3306  "
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M649.2685,271.1756l0.4741,0.3385c0.1259,0.0899,0.3024,0.0605,0.3923-0.0654l11.4061-15.9701 c0.0898-0.1259,0.0604-0.3024-0.0654-0.3923l-0.4741-0.3386c-0.1259-0.0899-0.3025-0.0604-0.3924,0.0655l-11.406,15.9701 C649.1132,270.9091,649.1427,271.0857,649.2685,271.1756z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M629.9446,268.2755l20.0739,3.7529c0.2365,0.0442,0.4662-0.1131,0.5104-0.3496l0.1665-0.8909 c0.0442-0.2366-0.1131-0.4663-0.3497-0.5105l-20.0737-3.7529c-0.2365-0.0442-0.4663,0.1132-0.5105,0.3497l-0.1666,0.8908 C629.5507,268.0015,629.7081,268.2313,629.9446,268.2755z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M609.2719,243.2225c0,0-1.3561,12.4424,2.0239,19.0843c-0.4976,2.2886,1.6754,2.8855,2.181,2.8855 c0.5055,0,6.4164,4.9012,22.2373,4.6027c0.6965-3.2836,0.8215-3.6151,0.8215-3.6151s-12.1511-7.387-17.0236-8.183 c0.2444-7.5258,0.092-12.9549,0.092-12.9549L609.2719,243.2225z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M634.0287,265.4849c0,0,3.2707,0.6008,6.0733-0.4905c2.8027-1.0913,5.1023,2.5018,5.1023,2.5018 s1.1625,2.01-0.6557,2.1222c-1.8181,0.1122-2.1738-0.9785-2.9393-0.9943c-0.7655-0.0158-0.7813,2.5809-6.4152,1.2637 C630.4854,268.7869,634.0287,265.4849,634.0287,265.4849z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M620.4227,256.5154c0,0,2.7875-19.5225-3.4351-22.9906c-7.7239-4.3049-8.9909,10.8497-8.0578,21.5099 C616.1614,256.4413,620.4227,256.5154,620.4227,256.5154z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M650.4634,316.4512l-1.564,4.8803c-0.1288,0.3476,0.0644,0.7317,0.4203,0.8353l14.4158,4.1536 c0,0,0.4299-1.5417-0.4063-3.1487c-0.8361-1.6069-4.785-2.5626-5.7271-4.9574c-0.4578-1.3325-2.2389-0.0738-3.0822,0.035 C653.6766,318.3582,650.4634,316.4512,650.4634,316.4512z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M620.4005,255.5414l-0.3985-0.0918c2.8636-12.5029,1.3184-17.8576-0.4832-20.1477 c-1.3328-1.6949-2.8301-1.7336-2.8445-1.7336l0.0049-0.4093c0.0692,0.0012,1.7097,0.0429,3.1617,1.8899 C621.6974,237.4095,623.301,242.8806,620.4005,255.5414z"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.5935,132.9005h-26.2028c-1.121,0-2.0382-0.9172-2.0382-2.0382v-50.107 c0-1.121,0.9172-2.0382,2.0382-2.0382h26.2028c1.121,0,2.0382,0.9171,2.0382,2.0381v50.1072 C342.6317,131.9833,341.7145,132.9005,340.5935,132.9005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.6851,
    y: 85.1989,
    className: "st4",
    width: 23.614,
    height: 40.3565
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.2756,131.494h-1.5671c-0.7899,0-1.4363-0.6463-1.4363-1.4363v-1.5671 c0-0.7899,0.6464-1.4363,1.4363-1.4363h1.5671c0.79,0,1.4363,0.6464,1.4363,1.4363v1.5671 C329.7119,130.8477,329.0656,131.494,328.2756,131.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "346.7155,106.2901 359.485,113.1333 359.485,113.1616 346.7155,120.0047 348.0134,113.1474  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 330.5643,
    y: 109.5777,
    className: "st5",
    width: 22.536,
    height: 7.1394
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 355.0414,
    y: 91.1414,
    className: "st5",
    width: 21.3446,
    height: 7.1393
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "359.485,87.8537 346.7155,94.6969 346.7155,94.7252 359.485,101.5683 358.1871,94.711  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.476,82.8602h-9.9679c-0.3232,0-0.5876-0.2644-0.5876-0.5876v-0.641 c0-0.3232,0.2644-0.5876,0.5876-0.5876h9.9679c0.3232,0,0.5876,0.2644,0.5876,0.5876v0.641 C333.0636,82.5958,332.7992,82.8602,332.476,82.8602z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.439,149.6178c-24.1563,0-43.8091-19.6528-43.8091-43.8091S311.2827,62,335.439,62 c24.1563,0,43.8083,19.6524,43.8083,43.8087S359.5953,149.6178,335.439,149.6178z M335.439,65.3017 c-22.3362,0-40.5074,18.1712-40.5074,40.507s18.1712,40.5074,40.5074,40.5074c22.3354,0,40.5066-18.1716,40.5066-40.5074 S357.7744,65.3017,335.439,65.3017z"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 519.1719,
    y: 205.0071,
    className: "st5",
    width: 33.1624,
    height: 44.6646
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.236,271.7356h-42.9957c-0.9656,0-1.8672-0.4828-2.4036-1.284 c-0.5362-0.8023-0.6368-1.8207-0.2666-2.7127l5.7807-13.9708l5.3404,2.2134l-4.1266,9.9728h38.6713V271.7356z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.9922,277.7824c0,2.4611-1.9949,4.4565-4.4565,4.4565c-2.4605,0-4.4554-1.9954-4.4554-4.4565 c0-2.461,1.9949-4.4559,4.4554-4.4559C519.9973,273.3265,521.9922,275.3214,521.9922,277.7824z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.5151,278.3066c0,2.4616-1.9955,4.4565-4.456,4.4565c-2.461,0-4.4559-1.9949-4.4559-4.4565 c0-2.4605,1.9949-4.4554,4.4559-4.4554C556.5196,273.8512,558.5151,275.8461,558.5151,278.3066z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.6468,230.4591l-2.1472-6.9268l-9.9683,2.1513l-1.2201-5.6514l12.5563-2.7099 c1.4667-0.3219,2.9288,0.5391,3.3708,1.9702l2.93,9.4567L506.6468,230.4591z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.0853,263.5646c-1.6793,0-3.1833-1.0828-3.7041-2.6979l-11.523-35.7688 c-0.4138-1.288-0.1287-2.6972,0.7524-3.7237c0.8776-1.0253,2.207-1.538,3.5633-1.3098l57.6606,9.1921v27.5267 c0,2.0472-1.588,3.7416-3.6283,3.8824l-42.8588,2.8915C520.2601,263.5605,520.1727,263.5646,520.0853,263.5646z  M514.2081,228.7452l8.6469,26.8408l36.1987-2.4391v-17.252L514.2081,228.7452z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 515.2489,
    y: 242.7188,
    className: "st0",
    width: 47.6952,
    height: 3.8904
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 529.0932,
    y: 227.3394,
    className: "st0",
    width: 3.8904,
    height: 31.4761
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 544.168,
    y: 231.6741,
    className: "st0",
    width: 3.891,
    height: 26.1914
  })))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2323 -0.9726 0.9726 0.2323 242.9157 597.5554)",
    className: "st5",
    cx: 499.998,
    cy: 144.8952,
    rx: 25.6694,
    ry: 25.6695
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M510.0872,150.1307c0,2.1304-0.7709,3.841-2.3115,5.1349c-1.5407,1.2933-3.6983,2.0662-6.4721,2.3213 v4.1199h-2.7528v-4.0387c-3.2688-0.0682-6.137-0.6436-8.6019-1.7285v-5.3062c1.1659,0.5755,2.5693,1.0853,4.2107,1.5264 c1.6406,0.4415,3.1054,0.7029,4.3912,0.7843v-6.2304l-1.3463-0.5229c-2.6527-1.0451-4.5329-2.1804-5.6372-3.406 c-1.1059-1.2256-1.6581-2.7428-1.6581-4.5523c0-1.9418,0.7598-3.5404,2.2805-4.7945c1.5209-1.2517,3.6411-2.0116,6.3611-2.2793 v-3.0746h2.7528v2.993c3.0693,0.1342,5.8415,0.7513,8.3211,1.8492l-1.8898,4.7042c-2.0895-0.8587-4.2328-1.3814-6.4313-1.568 v5.9274c2.6135,1.0054,4.4725,1.8776,5.5784,2.6135c1.1043,0.7378,1.9147,1.548,2.4309,2.431 C509.8288,147.9193,510.0872,148.9512,510.0872,150.1307z M495.9581,138.2325c0,0.5904,0.2045,1.0757,0.613,1.4581 c0.4086,0.3799,1.0685,0.7729,1.9797,1.175v-4.7239C496.8225,136.3964,495.9581,137.0946,495.9581,138.2325z M504.0379,150.4315 c0-0.562-0.2286-1.0386-0.684-1.4271c-0.4558-0.3889-1.1387-0.791-2.0503-1.206v5.005 C503.1265,152.4962,504.0379,151.7056,504.0379,150.4315z"
  })))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M592.2096,114.3664h27.0087c4.3938,0,7.9886,3.5949,7.9886,7.9885v9.5253 c0,4.2339-3.3406,7.7161-7.5148,7.9646v6.9983l-6.9742-6.9742h-20.5083c-4.3939,0-7.9887-3.5949-7.9887-7.9887v-9.5253 C584.2209,117.9613,587.8157,114.3664,592.2096,114.3664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M612.6356,127.3706c0,1.3915,1.1281,2.5194,2.5195,2.5194s2.5195-1.1279,2.5195-2.5194 c0-1.3915-1.128-2.5193-2.5195-2.5193S612.6356,125.9791,612.6356,127.3706z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M603.1944,127.3706c0,1.3915,1.1281,2.5194,2.5195,2.5194c1.3914,0,2.5196-1.1279,2.5196-2.5194 c0-1.3915-1.1282-2.5193-2.5196-2.5193C604.3225,124.8513,603.1944,125.9791,603.1944,127.3706z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M593.7533,127.3706c0,1.3915,1.128,2.5194,2.5194,2.5194c1.3915,0,2.5195-1.1279,2.5195-2.5194 c0-1.3915-1.128-2.5193-2.5195-2.5193C594.8813,124.8513,593.7533,125.9791,593.7533,127.3706z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M604.2286,89.2337h-31.3673c-5.1026,0-9.2778,4.1751-9.2778,9.2779v11.0622 c0,4.9173,3.8797,8.9613,8.7277,9.25v8.1276l8.0994-8.0996h23.818c5.1029,0,9.2779-4.175,9.2779-9.278V98.5116 C613.5065,93.4088,609.3315,89.2337,604.2286,89.2337z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M579.7006,104.0427c0,1.7781-1.4413,3.2192-3.2194,3.2192c-1.7778,0-3.2192-1.4411-3.2192-3.2192 c0-1.7779,1.4413-3.219,3.2192-3.219C578.2593,100.8237,579.7006,102.2648,579.7006,104.0427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M591.7644,104.0427c0,1.7781-1.4417,3.2192-3.2194,3.2192c-1.7779,0-3.2194-1.4411-3.2194-3.2192 c0-1.7779,1.4415-3.219,3.2194-3.219C590.3227,100.8237,591.7644,102.2648,591.7644,104.0427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M603.8279,104.0427c0,1.7781-1.4412,3.2192-3.2192,3.2192c-1.7779,0-3.2192-1.4411-3.2192-3.2192 c0-1.7779,1.4413-3.219,3.2192-3.219C602.3867,100.8237,603.8279,102.2648,603.8279,104.0427z"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.3952,166.5487c-26.7488,0-48.5107-21.7615-48.5107-48.5103c0-26.7487,21.7619-48.5102,48.5107-48.5102 c26.7488,0,48.5107,21.7615,48.5107,48.5102C643.9059,144.7872,622.144,166.5487,595.3952,166.5487z M595.3952,73.1842 c-24.7333,0-44.8547,20.1214-44.8547,44.8542c0,24.7329,20.1214,44.8543,44.8547,44.8543 c24.7333,0,44.8547-20.1214,44.8547-44.8543C640.2499,93.3056,620.1285,73.1842,595.3952,73.1842z"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.601,216.1196h-41.3751c-2.7855,0-5.0436-2.2581-5.0436-5.0436v-30.5873 c0-2.7855,2.2581-5.0435,5.0436-5.0435h41.3751c2.7855,0,5.0436,2.258,5.0436,5.0435v30.5873 C288.6446,213.8615,286.3865,216.1196,283.601,216.1196z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8723,175.4451h-41.9177c-2.6356,0-4.7722,2.1367-4.7722,4.7723v6.4926h51.4622v-6.4926 C288.6446,177.5818,286.508,175.4451,283.8723,175.4451z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 242.3725,
    y: 196.8659,
    className: "st4",
    width: 6.3978,
    height: 5.1284
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.0666,
    y: 196.8659,
    className: "st4",
    width: 6.3978,
    height: 5.1284
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.7607,
    y: 196.8659,
    className: "st4",
    width: 6.3979,
    height: 5.1284
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.4549,
    y: 196.8659,
    className: "st4",
    width: 6.3978,
    height: 5.1284
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 242.3725,
    y: 205.7419,
    className: "st4",
    width: 6.3978,
    height: 5.1283
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.0666,
    y: 205.7419,
    className: "st4",
    width: 6.3978,
    height: 5.1283
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.7607,
    y: 205.7419,
    className: "st4",
    width: 6.3979,
    height: 5.1283
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.4549,
    y: 205.7419,
    className: "st4",
    width: 6.3978,
    height: 5.1283
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.612,180.3969h-0.8206c-0.6361,0-1.1565-0.5204-1.1565-1.1564v-7.5907 c0-0.6361,0.5204-1.1565,1.1565-1.1565h0.8206c0.636,0,1.1564,0.5204,1.1564,1.1565v7.5907 C249.7684,179.8765,249.248,180.3969,248.612,180.3969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.0356,180.3969h-0.8206c-0.636,0-1.1564-0.5204-1.1564-1.1564v-7.5907 c0-0.6361,0.5204-1.1565,1.1564-1.1565h0.8206c0.6361,0,1.1565,0.5204,1.1565,1.1565v7.5907 C279.1921,179.8765,278.6717,180.3969,278.0356,180.3969z"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 279.8754,
    cy: 212.8274,
    r: 10.8331
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278.8189,217.4618c-0.328,0-0.656-0.1252-0.9063-0.3755l-2.9584-2.9585 c-0.5007-0.5007-0.5007-1.3118,0-1.8125c0.5-0.5007,1.3124-0.5007,1.8125,0l2.0522,2.0522l6.1331-6.1328 c0.5-0.5007,1.3124-0.5007,1.8125,0c0.5007,0.5007,0.5007,1.3118,0,1.8125l-7.0394,7.0391 C279.4751,217.3366,279.1468,217.4618,278.8189,217.4618z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.5,239.9862c-23.9997,0-43.5251-19.5254-43.5251-43.5251s19.5254-43.5247,43.5251-43.5247 s43.5243,19.525,43.5243,43.5247S290.4997,239.9862,266.5,239.9862z M266.5,156.2167c-22.1914,0-40.2448,18.0534-40.2448,40.2444 s18.0534,40.2448,40.2448,40.2448c22.1906,0,40.244-18.0538,40.244-40.2448S288.6906,156.2167,266.5,156.2167z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M551.6273,470.7695H255.1597V309.0766c0-5.2103,4.2238-9.4341,9.4341-9.4341h277.5994 c5.2104,0,9.4341,4.2238,9.4341,9.4341V470.7695z"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.1402,
    y: 315.4439,
    className: "st4",
    width: 274.9271,
    height: 155.8334
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M593.5983,513.0872H214.1586c-3.7366,0-6.7656-3.0291-6.7656-6.7656v-5.3736h392.9709v5.3736 C600.3639,510.0581,597.3348,513.0872,593.5983,513.0872z"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M441.9782,505.1238h-76.7489c-1.4221,0-2.5748-1.1528-2.5748-2.5748v-1.601h81.8985v1.601 C444.553,503.971,443.4002,505.1238,441.9782,505.1238z"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "551.7385,470.7695 255.2588,470.7695 207.393,500.948 599.6043,500.948  "
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.396,400.0862c-7.9309-7.6065-18.7177-12.2942-30.6131-12.2942c-0.0323,0-0.0641,0.0023-0.0963,0.0024 c-1.9344-37.4452-33.1123-67.2155-71.2914-67.2155c-5.6495,0-11.1438,0.6563-16.4139,1.8905 c-2.5438,0.5957-5.0909-0.8799-5.9877-3.3183c-12.91-35.102-46.8196-60.1619-86.6278-60.1619 c-49.1346,0-89.2882,38.1744-92.0508,86.2921c-0.1579,2.7511-2.4294,4.8644-5.2037,4.8616c-0.0172,0-0.0344,0-0.0516,0 c-30.2392,0-55.4107,21.498-60.903,49.9433c-0.7298,3.7799-1.1257,7.6778-1.1257,11.6692c0,12.5673,3.7969,24.2492,10.3021,33.9928 c0.9559,1.4318,2.5673,2.2986,4.297,2.2986h97.5452h113.1716h73.5809h12.5157h65.575c2.2651,0,4.2545-1.4774,4.9191-3.6284 c1.2542-4.0587,1.9334-8.3669,1.9334-12.8342C597.871,419.214,592.6992,408.05,584.396,400.0862z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "558.7357,488.3828 245.6927,488.3828 265.8852,474.4055 541.0673,474.4055  "
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.1597,
    y: 449.6791,
    className: "st16",
    width: 296.4676,
    height: 6.4131
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M322.285,285.9751l2.0697,15.5437c0,0,2.7069,1.861,4.2295,0c0.5921-3.8065,1.7734-20.0001,1.7734-20.0001 L322.285,285.9751z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M334.4722,287.1217l1.1408,18.0363c0,0,2.4593,1.7189,4.0121-0.5442 c1.5528-2.263,2.1836-21.4842,2.1836-21.4842L334.4722,287.1217z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M329.5961,299.2253l1.8035,4.6675c0.1457,0.3316-0.0235,0.7153-0.3681,0.8349l-13.1756,4.5715 c0,0-0.5065-1.4778,0.2287-3.0852c0.7352-1.6074,4.5676-2.7432,5.3642-5.1227c0.3779-1.3207,2.1983-0.1886,3.0337-0.1268 C327.318,301.0265,329.5961,299.2253,329.5961,299.2253z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M340.1702,303.2863c0,0,1.2902,4.8197-0.175,6.8023c-3.5037,0.718-5.8229,0.5573-7.1171-0.1831 c-0.0981-2.0734,0.7341-3.0117,1.626-4.302c0.4713-2.6143,0.5439-3.4711,0.5439-3.4711S338.6792,300.3807,340.1702,303.2863z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M353.7118,197.958c3.5475,2.9768,3.3565,8.7896,6.6955,11.9985c1.7007,1.6344,4.0587,2.3357,6.2477,3.2143 c2.189,0.8785,4.4482,2.1498,5.3554,4.327c0.4903,1.1766,1.0406,2.4045,1.0675,3.6789c0.0278,1.3207-1.1835,2.5959-1.1557,3.9165 c0.0183,0.8687,0.4618,2.8333,0.2808,3.6832c-0.6067,2.8487-3.0219,3.8395-5.7946,4.7319 c-3.7329,1.2015-7.8537,0.9669-11.5541-0.331c-3.7005-1.2978-6.9937-3.617-9.7277-6.4284 c-1.4179-1.4579-2.7108-3.0764-3.5182-4.943c-0.8074-1.8667-1.0976-4.0101-0.4986-5.9536 c0.4474-1.4518,1.3737-2.7728,1.4876-4.2878c0.2063-2.7444-2.2801-5.0511-2.4369-7.7989 c-0.1782-3.1201,2.8019-4.5453,5.0126-6.0046C347.7314,196.0723,351.2811,195.9184,353.7118,197.958z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M334.9311,224.9627c-0.7238,2.2593-0.9658,4.6554-1.7511,6.8942c-0.665,1.8961-1.704,3.6349-2.7359,5.3591 c-1.7589,2.9387-3.5178,5.8774-5.2768,8.8162c-0.2265,0.3785-0.4586,0.7732-0.5013,1.2124 c-0.1057,1.0878,1.0583,1.9683,2.1512,1.9486c1.0927-0.0198,2.0673-0.6715,2.91-1.3675 c5.5902-4.6161,8.1857-11.8109,11.8945-18.04c1.111-1.8657,2.3696-3.7548,2.591-5.915c0.1998-1.9494,0.7397-7.261-3.9916-6.4506 C337.7995,217.8349,335.5573,223.008,334.9311,224.9627z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M338.5685,218.3615c0,0,0.6435,2.3749,0.1467,4.1229c-0.4967,1.7479-2.5336,5.9919,1.1092,9.5104 c3.6428,3.5187,3.2034,11.8903,3.2034,11.8903s9.846,3.1148,15.4369-1.9175c1.9011-6.6826,1.9011-13.5863,1.9011-13.5863 s-3.6003-3.7323,0.0549-11.5193C346.1893,210.0145,338.5685,218.3615,338.5685,218.3615z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M346.3471,210.3183c0,0,0.0971,3.176-0.0179,3.568c-0.079,0.2698-1.2714,1.2731-2.0068,1.8724 c-0.3044,0.2479-0.3086,0.7081-0.011,0.9639c0.7621,0.6553,2.1405,1.7346,3.1147,1.8895 c1.3175,0.2096,4.437-0.1014,6.5277-2.7102c0.2462-0.3072,0.1438-0.7672-0.2043-0.9511 c-1.9515-1.0315-2.0593-0.9032-2.1787-1.4679c-0.1314-0.6211-1.5557-7.0696-1.5557-7.0696L346.3471,210.3183z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M350.0457,209.4224l-3.6697,2.4079c-0.047,0.8999-0.1122,1.8415-0.1867,2.0465 C349.8742,212.9746,350.0457,209.4224,350.0457,209.4224z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M364.6799,256.5806c-1.1516,2.2935-2.3324,4.0529-4.4336,5.5264 c-2.9756,2.0865-13.8587,5.5827-15.2466,7.6742c-1.5246,2.2976-1.5895,5.2242-1.7783,7.9751 c-0.2699,3.9316,0.0706,7.9248-1.2609,11.6338c-0.5784,1.6117-4.5612,1.8244-6.6954,1.2301 c-0.4601-0.1281-0.7857-0.5431-0.8313-1.0185c-0.7092-7.405-0.984-13.9948-0.9924-21.4914 c-0.0019-1.6905,0.0212-3.4212,0.6089-5.0061c0.8163-2.2011,2.6236-1.3807,4.4541-2.8503 c4.4062-3.5377,9.2913-6.4239,14.3069-9.0042c2.5192-1.296,5.0762-2.5171,7.6429-3.7161c0.91-0.4252,1.377-1.5865,2.3538-1.1442 c0.8633,0.3909,1.5948,1.9497,1.9533,2.7643C365.7876,251.4858,365.8325,254.2848,364.6799,256.5806z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M357.9841,239.1255c0,0,4.5482,3.0134,7.3892,12.0132c-8.3418,6.8692-26.0974,2.3839-26.7471,0.2184 c-0.6497-2.1656,4.4016-10.8908,4.4016-10.8908L357.9841,239.1255z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M344.1331,244.3686l2.719,8.6757c-0.2023,2.2944-0.0572,4.7763-1.7938,6.2894 c-2.1955,1.9128-5.5685,1.5797-8.0459,3.11c-1.4506,0.896-4.182,1.611-4.9967,3.1087c-0.6366,1.1703-0.6817,2.9208-0.7614,4.2506 c-0.3645,6.0901-0.296,17.3832-1.732,18.6706c-1.3374,1.1992-6.0925,1.3415-6.8998-0.2957 c-1.3223-4.7069-3.0363-20.5894-2.4866-24.061c0.2868-1.8115,0.8714-1.0855,1.7232-2.7098 c1.1854-2.2605,2.87-4.2256,4.7061-5.9986c2.7626-2.6677,5.9011-4.9457,9.2937-6.7456c0.8405-0.4457,1.7153-0.8685,2.658-0.9969 L344.1331,244.3686z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "342.6487,259.8245 318.8035,259.8245 328.2286,250.9091 352.0737,250.9091  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "342.6487,259.8245 318.9475,259.8245 313.9577,243.8851 337.6589,243.8851  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M361.6962,217.1057c1.3386,0.8183,2.1624,2.2517,2.8588,3.6575c2.2167,4.4756,3.7145,9.2818,4.7733,14.1628 c0.183,0.8437,0.354,1.7045,0.2783,2.5645c-0.1269,1.4437-0.9479,2.7554-1.996,3.7565c-1.048,1.001-2.3176,1.7339-3.5736,2.4569 c-2.1124,1.2159-4.2249,2.4319-6.3373,3.6477c-1.5987,0.9202-3.204,1.8437-4.9162,2.5298 c-0.3333,0.1336-0.6841,0.26-1.0421,0.2303c-0.4436-0.037-0.8289-0.3066-1.1901-0.5669 c-0.7197-0.5188-1.5147-1.1794-1.5004-2.0665c0.0089-0.5466,0.3345-1.0321,0.662-1.4699 c3.041-4.066,7.3567-7.1641,12.1817-8.7451c0.2778-0.091,0.5882-0.2035,0.7089-0.4698c0.0712-0.1572,0.0598-0.338,0.0401-0.5094 c-0.3702-3.2115-3.047-5.6068-4.4854-8.5019c-0.9254-1.8623-1.3332-3.9365-1.6141-5.9969 C356.1185,218.6626,357.9619,214.8229,361.6962,217.1057z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M350.318,245.6625c0,0-2.4416,1.0054-3.5188,2.5853c-1.0772,1.5799-3.0161,4.0933-1.8671,4.6678 c1.1489,0.5745,3.3033-0.1383,4.1651-1.3976c0.8618-1.2595,2.3698-2.6239,3.3752-3.342 C353.4778,247.4579,351.9697,246.0934,350.318,245.6625z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M342.8843,204.984c0,0,0.0865,4.8772,2.979,6.6817c0.3101,0.1936,0.7086,0.251,1.0585,0.1453 c2.1316-0.644,2.7912-2.9829,3.0594-4.211c0.7978-0.7924,0.8798-3.2106-1.3333-2.3649 c-1.2815,0.2182-1.3505-2.2962-2.7822-3.0178C345.8657,202.2173,343.6589,200.8562,342.8843,204.984z"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M132.9208,334.5903c0,0-17.2861-8.7213-36.1968,0.6959 C109.4411,344.1555,128.2466,342.3696,132.9208,334.5903z"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122.5229,338.1227c0,0,5.6605-1.5491,3.4559-12.7507c-0.5958-3.5751,2.6397-10.2254,0.1191-14.8363 c-1.9245-3.5205-4.7406-5.425-7.7457-6.3159c-4.1113-1.1916-9.593-1.9662-12.155,8.8779 c-2.5621,10.8442-4.9454,8.2225-8.4013,13.0488c-3.4558,4.8263-2.145,7.865,1.1321,8.58 c3.2771,0.7149,4.1707,4.7071,8.4608,2.2045C111.6788,334.4286,116.4454,339.4336,122.5229,338.1227z"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.5347,334.1614c0,0,4.7209,0.2425,8.239,6.8771c3.518,6.6346,3.7663,11.062,5.7616,17.3048 c1.6117,5.0433,4.1778,8.9747,4.1778,8.9747s5.3686-1.1759,18.2367-11.3778c3.0864,6.1811,3.4788,5.651,3.4788,5.651 s-13.4246,15.1148-23.3742,16.2977c-1.3846,0.1645-2.7806-0.3584-3.6384-1.2595c-10.4439-10.9698-12.8813-26.0454-12.8813-26.0454 V334.1614z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "191.2756,337.6519 171.5451,336.0642 150.0961,366.1876 169.0343,368.0761  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.2756,368.0761 191.2756,337.7139 191.2756,368.0761  "
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "189.8048,368.0761 189.8048,336.0642 191.2756,336.0642 191.2756,337.6729 191.2756,368.0761  "
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.3342,
    y: 336.0642,
    className: "st4",
    width: 1.4706,
    height: 32.0119
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.8634,
    y: 336.0642,
    className: "st4",
    width: 1.4708,
    height: 32.0119
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.3928,
    y: 336.0642,
    className: "st4",
    width: 1.4706,
    height: 32.0119
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.922,
    y: 336.0642,
    className: "st20",
    width: 1.4708,
    height: 32.0119
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.4514,
    y: 336.0642,
    className: "st21",
    width: 1.4706,
    height: 32.0119
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.9806,
    y: 336.0642,
    className: "st22",
    width: 1.4708,
    height: 32.0119
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.51,
    y: 336.0642,
    className: "st22",
    width: 1.4706,
    height: 32.0119
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.0392,
    y: 336.0642,
    className: "st23",
    width: 1.4708,
    height: 32.0119
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.5686,
    y: 336.0642,
    className: "st24",
    width: 1.4706,
    height: 32.0119
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.0978,
    y: 336.0642,
    className: "st25",
    width: 1.4708,
    height: 32.0119
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.6272,
    y: 336.0642,
    className: "st25",
    width: 1.4706,
    height: 32.0119
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.1564,
    y: 336.0642,
    className: "st26",
    width: 1.4708,
    height: 32.0119
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.6858,
    y: 336.0642,
    className: "st27",
    width: 1.4706,
    height: 32.0119
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.2151,
    y: 336.0642,
    className: "st28",
    width: 1.4707,
    height: 32.0119
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.7444,
    y: 336.0642,
    className: "st29",
    width: 1.4707,
    height: 32.0119
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.2737,
    y: 336.0642,
    className: "st30",
    width: 1.4707,
    height: 32.0119
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.803,
    y: 336.0642,
    className: "st31",
    width: 1.4707,
    height: 32.0119
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 163.3323,
    y: 336.0642,
    className: "st32",
    width: 1.4707,
    height: 32.0119
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.8616,
    y: 336.0642,
    className: "st33",
    width: 1.4707,
    height: 32.0119
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3909,
    y: 336.0642,
    className: "st34",
    width: 1.4707,
    height: 32.0119
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 158.9202,
    y: 336.0642,
    className: "st35",
    width: 1.4707,
    height: 32.0119
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.4495,
    y: 336.0642,
    className: "st36",
    width: 1.4707,
    height: 32.0119
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.9788,
    y: 336.0642,
    className: "st37",
    width: 1.4707,
    height: 32.0119
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 154.5081,
    y: 336.0642,
    className: "st38",
    width: 1.4707,
    height: 32.0119
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.0375,
    y: 336.0642,
    className: "st39",
    width: 1.4706,
    height: 32.0119
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.5667,
    y: 336.0642,
    className: "st40",
    width: 1.4708,
    height: 32.0119
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "150.0961,366.2216 150.0961,336.0642 151.5667,336.0642 151.5667,368.0761 150.0961,368.0761  "
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "150.0961,336.0642 150.0961,366.2216 150.0961,336.0642  "
  })))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.4756,376.2185c1.2214-6.2847,0.0355-9.1783,3.0536-23.1008c3.9264-18.1124,11.9418-18.48,11.9418-18.48 c4.4485-0.7766,4.3101,13.3146,4.3101,13.3146l-1.4691,3.2245c-1.998,5.2923-6.6287,18.274-5.0339,20.9652 c2.0133,3.397,3.2797,9.1723-3.0309,11.3469C86.9363,385.6635,82.2542,382.5034,83.4756,376.2185z"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.9345,331.8981l8.5458,2.8837c0,0,2.1066,6.5242,3.1337,9.3199 c1.027,2.7956,4.8786,9.4808-0.6419,15.6797c-5.5204,6.199-5.5674,20.1031-5.5674,20.1031s-15.2058,5.8764-24.9627-1.6597 c-1.2839-11.547-5.9553-21.4844-5.9553-21.4844s6.9327-8.6239,0-20.9003c6.5336-3.1244,10.5853-3.9715,10.5853-3.9715 L122.9345,331.8981z"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.2999,378.7774c0,0-5.2999,11.1432-3.5012,35.0185c1.7986,23.8754,12.0074,94.2996,12.0074,94.2996 l9.3087,1.2349c0,0-0.8087-61.9461,4.258-106.4576C110.5816,384.8245,98.2999,378.7774,98.2999,378.7774z"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.0893,379.5447c0,0,17.0011,27.6976,19.5395,66.9989c0.0917,1.42-0.0291,2.8596-0.332,4.2499 c-9.6227,44.1739-15.5891,59.0138-15.5891,59.0138h-8.1415c0,0,0.8161-31.5678,8.3546-60.8167 c-12.5873-27.7509-17.099-36.2771-17.099-36.2771l-12.0614-33.1688H129.0893z"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M124.5602,506.7858l-1.5758,7.2976c-0.1377,0.5226,0.2007,1.049,0.7361,1.1453l20.4795,3.6825 c0,0,0.4039-2.2955-1.0524-4.4941s-7.3684-2.9841-9.0942-6.3064c-0.8632-1.8589-3.2836,0.2318-4.5008,0.5167 C128.3356,508.9124,124.5602,506.7858,124.5602,506.7858z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "83.281,359.2987 108.0184,356.2106 119.3984,383.9852 95.2314,387.4575  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "119.3984,387.4575 119.3984,383.9621 119.3984,387.4575  "
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "118.1084,387.4575 118.1084,356.2106 119.3984,356.2106 119.3984,384.003 119.3984,387.4575  "
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 116.8185,
    y: 356.2106,
    className: "st4",
    width: 1.2899,
    height: 31.2469
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 115.5286,
    y: 356.2106,
    className: "st4",
    width: 1.2899,
    height: 31.2469
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.2388,
    y: 356.2106,
    className: "st4",
    width: 1.2898,
    height: 31.2469
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112.9488,
    y: 356.2106,
    className: "st20",
    width: 1.29,
    height: 31.2469
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.6589,
    y: 356.2106,
    className: "st21",
    width: 1.2899,
    height: 31.2469
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.3691,
    y: 356.2106,
    className: "st22",
    width: 1.2898,
    height: 31.2469
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.0791,
    y: 356.2106,
    className: "st22",
    width: 1.29,
    height: 31.2469
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.7892,
    y: 356.2106,
    className: "st23",
    width: 1.2899,
    height: 31.2469
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.4993,
    y: 356.2106,
    className: "st24",
    width: 1.2899,
    height: 31.2469
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.2094,
    y: 356.2106,
    className: "st25",
    width: 1.2899,
    height: 31.2469
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.9195,
    y: 356.2106,
    className: "st25",
    width: 1.2899,
    height: 31.2469
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.6296,
    y: 356.2106,
    className: "st26",
    width: 1.2899,
    height: 31.2469
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.3396,
    y: 356.2106,
    className: "st27",
    width: 1.29,
    height: 31.2469
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.0498,
    y: 356.2106,
    className: "st28",
    width: 1.2898,
    height: 31.2469
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.7599,
    y: 356.2106,
    className: "st29",
    width: 1.2899,
    height: 31.2469
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.4699,
    y: 356.2106,
    className: "st30",
    width: 1.29,
    height: 31.2469
  })))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.18,
    y: 356.2106,
    className: "st31",
    width: 1.2899,
    height: 31.2469
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.8902,
    y: 356.2106,
    className: "st32",
    width: 1.2898,
    height: 31.2469
  })))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.6002,
    y: 356.2106,
    className: "st33",
    width: 1.29,
    height: 31.2469
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.3103,
    y: 356.2106,
    className: "st34",
    width: 1.2899,
    height: 31.2469
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.0205,
    y: 356.2106,
    className: "st35",
    width: 1.2898,
    height: 31.2469
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.7305,
    y: 356.2106,
    className: "st36",
    width: 1.29,
    height: 31.2469
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.4406,
    y: 356.2106,
    className: "st37",
    width: 1.2899,
    height: 31.2469
  })))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.1507,
    y: 356.2106,
    className: "st38",
    width: 1.2899,
    height: 31.2469
  })))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.8609,
    y: 356.2106,
    className: "st39",
    width: 1.2898,
    height: 31.2469
  })))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.5709,
    y: 356.2106,
    className: "st40",
    width: 1.29,
    height: 31.2469
  })))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.281,359.2964 83.281,356.2106 84.5709,356.2106 84.5709,387.4575 83.281,387.4575  "
  })))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.281,356.2106 83.281,359.2964 83.281,356.2106  "
  })))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.5119,380.2647c-0.4279-0.7254-0.1749-1.6607,0.5644-2.0641c1.0255-0.5598,2.37-1.2737,2.9266-1.4818 c0.9556-0.3574,7.9754-0.7259,7.9754-0.7259s2.4033,2.0578,0.4909,4.0176c-1.9124,1.96-4.3479,3.7264-4.3479,3.7264 S93.1502,386.4326,89.5119,380.2647z"
  })))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M120.0142,323.2872c0,0,0.1713,5.1944,0.3996,5.8223c0.2282,0.6278,4.4522,3.5389,4.4522,3.5389 s-3.4687,3.7754-5.752,4.289c-2.2832,0.5139-8.0129,0.265-11.7146-4.6885c4.0528-2.5686,4.2667-2.2261,4.4166-3.2536 c0.1499-1.0274,1.8053-11.7015,1.8053-11.7015L120.0142,323.2872z"
  })))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.5499,322.0432l5.5608,3.6486c0.0711,1.3636,0.1699,2.7904,0.2828,3.1011 C114.8097,327.4257,114.5499,322.0432,114.5499,322.0432z"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.8492,312.6796c0,0,1.6698,8.2507-2.5325,12.3684c-0.4506,0.4415-1.1006,0.6865-1.7297,0.6387 c-3.8315-0.2915-5.8138-3.9875-6.7227-5.957c-1.6396-1.0384-2.678-5.0826,1.3662-4.4814c2.2408-0.1094,1.421-4.3722,3.5649-6.1211 C117.7954,309.1272,121.0073,306.0121,123.8492,312.6796z"
  })))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.5394,316.8602c0,0-3.3152-0.4277-5.1868-4.5451s-4.0105-4.5452-4.0105-4.5452l6.1493-0.5882 C123.4914,307.1817,127.0742,308.9463,126.5394,316.8602z"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.4945,506.9438c0,0,1.9251,7.191-0.2611,10.1492c-5.2275,1.0712-8.6879,0.8314-10.6188-0.2733 c-0.1464-3.0936,1.0954-4.4934,2.426-6.4186c0.7033-3.9006,0.8115-5.1789,0.8115-5.1789S113.2699,502.6086,115.4945,506.9438z"
  })))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M178.1174,357.7095c0.7477-4.1035-2.9593-5.4973-3.9628-5.6365c-1.0035-0.1392-2.5554,2.7007-1.9123,5.9345 c0.6433,3.2339-2.8372,7.9948-2.8372,7.9948S176.5534,366.2943,178.1174,357.7095z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "392.4075,162.318 385.0808,179.6914 377.2673,173.668 382.6404,160.9276  "
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "385.0103,183.4048 392.1146,200.8703 382.3305,202.136 377.1206,189.3279  "
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "412.5485,152.638 395.0829,159.7421 393.8171,149.9583 406.6252,144.7485  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "394.6902,203.5458 412.0635,210.8724 406.0403,218.6856 393.2997,213.3128  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "415.7769,210.9428 433.2425,203.8385 434.5081,213.6226 421.7,218.8324  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "435.9179,201.2628 443.2445,183.8894 451.0579,189.9126 445.685,202.6532  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "443.3149,180.1762 436.2108,162.7108 445.995,161.445 451.2048,174.253  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "433.6351,160.035 416.2617,152.7086 422.2852,144.8952 435.0257,150.2679  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.6938,209.9771c-15.3986,6.2636-33.0226-1.1688-39.2861-16.5674 c-6.2633-15.3983,1.1688-33.0223,16.5675-39.2858c15.3986-6.2633,33.0226,1.1688,39.2859,16.5674 C448.5246,186.09,441.0925,203.7136,425.6938,209.9771z M406.6592,163.1812c-10.4047,4.2321-15.4261,16.1399-11.194,26.5446 c4.2322,10.4045,16.1396,15.4263,26.5446,11.1941c10.4047-4.2321,15.4261-16.1399,11.194-26.5445 C428.9716,163.9707,417.0642,158.9489,406.6592,163.1812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.3897,192.0202c-5.4972,2.2361-11.789-0.4172-14.0251-5.9143 c-2.2359-5.4972,0.4176-11.7891,5.9147-14.0251c5.4972-2.2359,11.7891,0.4173,14.0249,5.9145 C426.5403,183.4924,423.8868,189.7842,418.3897,192.0202z M412.3589,177.1936c-2.678,1.0895-3.9708,4.1545-2.8816,6.8327 c1.0896,2.678,4.1548,3.9708,6.8328,2.8813c2.6784-1.0893,3.9708-4.1544,2.8816-6.8328 C418.1022,177.3967,415.0369,176.1043,412.3589,177.1936z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.3618,221.2103c0-0.2953-0.0685-0.5719-0.0872-0.8628l4.0539-3.4104l-4.5709-7.9161l-4.5759,1.6585 c-0.7272-0.5729-1.5049-1.0715-2.3415-1.4869l-0.926-5.2106h-9.1404l-0.8437,4.7457c-0.8888,0.3552-1.7392,0.7834-2.5228,1.3109 l-4.9194-1.7836l-4.5708,7.9161l3.7177,3.1281c-0.0907,0.6297-0.193,1.2569-0.193,1.9111c0,0.2953,0.0685,0.572,0.0871,0.8627 l-4.0539,3.4104l4.5709,7.916l4.576-1.6582c0.7271,0.5727,1.5051,1.0712,2.3417,1.4867l0.9258,5.2105h9.1407l0.8434-4.7457 c0.8887-0.3549,1.7391-0.7834,2.5227-1.3108l4.9194,1.7835l4.5709-7.916l-3.7177-3.1282 C470.2595,222.4915,470.3618,221.8644,470.3618,221.2103z M456.9018,227.0488c-3.2199,0-5.8388-2.6185-5.8388-5.8385 c0-3.2201,2.6189-5.8387,5.8388-5.8387c3.2199,0,5.8387,2.6186,5.8387,5.8387 C462.7405,224.4303,460.1217,227.0488,456.9018,227.0488z"
  })))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 425.7539,
    y: 210.1338,
    className: "st0",
    width: 3.7793,
    height: 106.4717
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.3813,412.4258c0,0,4.7231,4.7861,11.335,4.7861c4.1562,0,7.6826-2.3301,7.6826-6.5488 c0-9.6348-21.5366-7.5566-21.5366-21.2217c0-6.9277,5.9824-12.4062,14.3579-12.4062c8.2495,0,12.5947,4.4717,12.5947,4.4717 l-2.834,5.1631c0,0-4.0933-3.8408-9.7607-3.8408c-4.7231,0-8.0605,2.96-8.0605,6.4863c0,9.1934,21.5366,6.7373,21.5366,21.1582 c0,6.8643-5.2896,12.5322-14.106,12.5322c-9.4458,0-14.7354-5.8564-14.7354-5.8564L264.3813,412.4258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314.0063,402.3506h1.3857v-0.5664c0-5.2275-2.96-6.9902-6.9902-6.9902c-4.9116,0-8.8789,3.0859-8.8789,3.0859 l-2.519-4.4717c0,0,4.5972-3.7783,11.9019-3.7783c8.0605,0,12.5947,4.4082,12.5947,12.4688V422.25h-5.668v-3.0225 c0-1.4482,0.126-2.5195,0.126-2.5195h-0.126c0,0-2.5815,6.2979-10.2012,6.2979c-5.479,0-10.8315-3.3379-10.8315-9.6982 C294.7998,402.791,308.6538,402.3506,314.0063,402.3506z M306.9536,418.0938c5.1636,0,8.5015-5.416,8.5015-10.1387v-1.0078h-1.5747 c-4.5967,0-12.9092,0.3154-12.9092,6.0459C300.9712,415.5752,302.9863,418.0938,306.9536,418.0938z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.2568,377.791h6.1084v34.6982c0,3.8408,1.5112,4.5342,3.4004,4.5342c0.5669,0,1.0708-0.0635,1.0708-0.0635 v5.416c0,0-0.9448,0.126-2.0151,0.126c-3.4639,0-8.5645-0.9443-8.5645-8.9424V377.791z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.0522,389.6299c9.0049,0,13.791,6.6748,13.791,14.9248c0,0.8184-0.189,2.6445-0.189,2.6445h-23.2368 c0.3145,6.9902,5.2896,10.5166,10.957,10.5166c5.4785,0,9.4458-3.7148,9.4458-3.7148l2.519,4.4707 c0,0-4.7227,4.5342-12.3428,4.5342c-10.0127,0-16.8765-7.2422-16.8765-16.6885 C345.1201,396.1787,351.9839,389.6299,361.0522,389.6299z M368.6089,402.6025c-0.189-5.4785-3.5894-8.124-7.6826-8.124 c-4.6602,0-8.4385,2.8975-9.3203,8.124H368.6089z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M382.6543,414.001c0,0,3.5898,3.7148,9.1313,3.7148c2.6445,0,5.29-1.3857,5.29-3.9668 c0-5.8564-16.3735-4.6602-16.3735-15.0508c0-5.7939,5.1641-9.0684,11.5239-9.0684c6.9902,0,10.2651,3.5264,10.2651,3.5264 l-2.4565,4.5977c0,0-2.833-2.834-7.8711-2.834c-2.645,0-5.2271,1.1328-5.2271,3.9043c0,5.7305,16.374,4.4707,16.374,14.9248 c0,5.2891-4.5347,9.2568-11.5249,9.2568c-7.8086,0-12.0908-4.6602-12.0908-4.6602L382.6543,414.001z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M416.3486,383.207h-15.2402v-5.416h36.7139v5.416H422.583v39.043h-6.2344V383.207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M452.3086,389.6299c9.5088,0,17.1914,6.9902,17.1914,16.625c0,9.6982-7.6826,16.751-17.1914,16.751 s-17.1914-7.0527-17.1914-16.751C435.1172,396.6201,442.7998,389.6299,452.3086,389.6299z M452.3086,417.7158 c6.0459,0,10.957-4.7861,10.957-11.4609c0-6.6123-4.9111-11.335-10.957-11.335c-5.9824,0-10.957,4.7227-10.957,11.335 C441.3516,412.9297,446.3262,417.7158,452.3086,417.7158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M491.6074,389.6299c9.5088,0,17.1914,6.9902,17.1914,16.625c0,9.6982-7.6826,16.751-17.1914,16.751 s-17.1914-7.0527-17.1914-16.751C474.416,396.6201,482.0986,389.6299,491.6074,389.6299z M491.6074,417.7158 c6.0459,0,10.957-4.7861,10.957-11.4609c0-6.6123-4.9111-11.335-10.957-11.335c-5.9824,0-10.957,4.7227-10.957,11.335 C480.6504,412.9297,485.625,417.7158,491.6074,417.7158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M515.667,377.791h6.1084v34.6982c0,3.8408,1.5117,4.5342,3.4004,4.5342c0.5664,0,1.0703-0.0635,1.0703-0.0635 v5.416c0,0-0.9443,0.126-2.0146,0.126c-3.4639,0-8.5645-0.9443-8.5645-8.9424V377.791z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M419.9282,345.9294c-1.7173-0.7223-3.1994-1.3459-3.1994-2.7496c0-1.2539,1.2368-2.2386,2.8144-2.2386 c1.9933,0,3.4652,1.3561,3.4788,1.3697l0.1295,0.1193l1.1721-2.1364l-0.0715-0.0716c-0.0681-0.0681-1.6662-1.6797-4.7088-1.6797 c-3.0768,0-5.3937,2.0103-5.3937,4.6781c0,2.811,2.4123,3.8604,4.5385,4.7906c1.7956,0.7837,3.3459,1.4583,3.3459,2.9813 c0,1.5605-1.3425,2.259-2.6747,2.259c-2.334,0-4.0342-1.6934-4.0512-1.7104l-0.1125-0.1124l-1.4549,1.9489l0.075,0.0852 c0.0204,0.0204,2.0171,2.1909,5.4959,2.1909c3.1211,0,5.3017-1.9421,5.3017-4.7259 C424.6166,347.9022,422.1259,346.8562,419.9282,345.9294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.7755,346.2224c1.0971-0.8723,1.4617-1.7445,1.4617-3.2028c0-2.0273-1.3356-4.1943-5.087-4.1943h-2.886 h-2.4021v16.5525l0,0l0,0h6.3307c3.2062,0,4.9814-1.6321,4.9984-4.593C324.1981,349.2208,323.152,347.3877,321.7755,346.2224z  M318.1468,341.0638c1.891,0,2.8042,0.6576,2.8484,1.9557c0.0307,0.8723-0.1261,1.3459-1.3561,1.9898l-4.3783,2.1193v-6.0649 C315.2608,341.0638,318.1468,341.0638,318.1468,341.0638z M319.1928,353.1425h-3.932v-3.564l4.3783-2.1193 c1.1346,0.552,2.3169,2.1909,2.3101,3.3118C321.9425,352.1953,321.4723,353.1425,319.1928,353.1425z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "331.953,348.1611 337.7862,348.1611 337.7862,345.9021 331.953,345.9021 331.953,341.0809  339.1218,341.0809 339.1218,338.8253 329.3941,338.8253 329.3941,355.3777 339.5137,355.3777 339.5137,353.1221 331.953,353.1221  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M480.6659,338.8253v10.7192c0,0.5349,0.0579,1.2709,0.1022,1.7786c-0.276-0.5145-0.7224-1.305-1.0971-1.8569 l-7.2404-10.5829l-0.0409-0.0613h-2.4702v16.5524h2.5588v-10.6988c0-0.5486-0.0579-1.2913-0.1022-1.8024 c0.276,0.5145,0.7224,1.3118,1.0971,1.8774l7.3051,10.6204h2.4464v-16.5456H480.6659z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "461.231,345.9737 453.0672,345.9737 453.0672,338.8253 450.5083,338.8253 450.5083,355.3777  453.0672,355.3777 453.0672,348.2293 461.231,348.2293 461.231,355.3777 463.7898,355.3777 463.7898,338.8253 461.231,338.8253  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M401.5154,338.8253h-5.5334v16.5525h5.5334c5.1756,0,8.3921-3.179,8.3921-8.3001 C409.9041,341.9872,406.6911,338.8253,401.5154,338.8253z M401.3519,353.1221h-2.8144v-12.0412h2.8144 c3.7105,0,5.9252,2.242,5.9252,5.9968C407.2805,350.8631,405.0624,353.1221,401.3519,353.1221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M436.9986,338.5493c-4.7701,0-8.5079,3.7071-8.5079,8.4398c0,4.8622,3.7378,8.6681,8.5079,8.6681 c4.7565,0,8.4841-3.8093,8.4841-8.6681C445.4826,342.253,441.7551,338.5493,436.9986,338.5493z M436.9986,353.2822 c-3.2982,0-5.8809-2.7667-5.8809-6.2966c0-3.4141,2.5827-6.0887,5.8809-6.0887c3.2846,0,5.8571,2.6747,5.8571,6.0887 C442.8556,350.5156,440.2832,353.2822,436.9986,353.2822z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.7645,348.2157c1.7479-0.644,2.8655-2.3851,2.8655-4.4806c0-2.1397-1.0869-3.8774-2.8348-4.5316 c-0.6303-0.2317-1.3663-0.3782-3.0904-0.3782h-5.1177v16.5525h2.5589v-6.4772h3.2607l3.4345,6.4806h2.8961l-3.5674-6.5249 C352.9893,348.5359,352.8496,348.3315,352.7645,348.2157z M350.284,346.6415h-3.1381v-5.5606h2.4907 c1.2505,0,1.7581,0.1363,2.1704,0.351c0.7973,0.4429,1.2198,1.2709,1.2198,2.3919 C353.0268,345.5614,351.9774,346.6415,350.284,346.6415z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "363.9096,348.1611 369.7428,348.1611 369.7428,345.9021 363.9096,345.9021 363.9096,341.0809  371.0785,341.0809 371.0785,338.8253 361.3507,338.8253 361.3507,355.3777 371.4703,355.3777 371.4703,353.1221 363.9096,353.1221  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M387.2902,349.5445c0,0.5349,0.0579,1.2709,0.1022,1.7786c-0.276-0.5145-0.7224-1.305-1.0971-1.8569 l-7.2404-10.5829l-0.0409-0.0613h-2.4702v16.5524h2.5588v-10.6988c0-0.5486-0.0579-1.2913-0.1022-1.8024 c0.276,0.5145,0.7224,1.3118,1.0971,1.8774l7.3052,10.6204h2.4464v-16.5456h-2.5588V349.5445z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", null)), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", null)), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", null)), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", null)), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", null)), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDashboard);
export default __webpack_public_path__ + "static/media/backgroundDashboard.62be0b0875543a4c9d8210278c116076.svg";
export { ForwardRef as ReactComponent };